import dayjs from 'dayjs'
import {
  deleteAPICall,
  downloadAPICall,
  getAPICall,
  patchAPICall,
  postAPICall
} from './apiCall'

export const getSelectOptionsByTableName = ({
  tableName,
  page = -1,    
  filters,
  search
}) => {
  let url = `items/${tableName}`
  let options = []

  if (page !== undefined && page !== null) options.push(`page=${page}`)
  if (filters) options.push(`filters=${filters}`)
  if (search) options.push(`search=${search}`)

  if (options.length) url += `?${options.join('&')}`

  return getAPICall(url)
}

export const fileUploadAPI = ({ body, tableName = 'others' }) => {
  return postAPICall(`document-upload/${tableName}`, {
    body,
    headers: { headers: { 'Content-Type': 'multipart/form-data' } }
  })
}

export const bulkUploadAPI = ({
  body,
  tableName = 'others',
  returnErrorObject = false
}) => {
  return postAPICall(`upload/${tableName}`, {
    body,
    headers: { headers: { 'Content-Type': 'multipart/form-data' } },
    returnErrorObject
  })
}

export const getFileTemplate = async ({ tableName = 'users', fileName }) => {
  return downloadAPICall(`template/${tableName}`, { fileName })
}

export const exportTableDetails = ({
  source,
  search,
  type,
  filter,
  sort,
  fileType = 'xlsx'
}) => {
  let url = `download/${source}?file_type=${fileType}`;

  if (search) url += `&search=${search}`;

  if (filter && Object.entries(filter)?.length) {
    const filterArr = [];

    Object.entries(filter).forEach(([key, value]) => {
      if (value != null && value?.length > 0) {
        filterArr.push(
          `"${key}":${
            key.endsWith('_in') && value?.length > 0
              ? `[${value.map(i => `"${i}"`)}]`
              : key.endsWith('_gte')
              ? key.includes('_time')
                ? `"${value}"`
                : `"${dayjs(value).format('YYYY-MM-DD')} 00:00:00"`
              : key.endsWith('_lte')
              ? key.includes('_time')
                ? `"${value}"`
                : `"${dayjs(value).format('YYYY-MM-DD')} 23:59:59"`
              : `"${value}"`
          }`
        );
      }
    });

    if (filterArr.length) {
      url += `&filters={${filterArr.join(',')}}`;
    }
  }

  if (!filter || !Object.entries(filter)?.length) {
    if (type) {
      url += `&filters={"status_in":[${type}]}`;
    }
  }

  if (sort?.[0]) {
    url += `&sort_by=${sort.map(d => (d.desc ? `-${d.id}` : d.id)).join(',')}`;
  }

  return getAPICall(url, { returnObject: true });
};

export const getAllData = ({
  source,
  page = -1,
  search,
  type,
  fileType,
  filter,
  sort,
}) => {
  let url = `items/${source}?page=${fileType ? -1 : page}`;
  let filterArr = [];
  if (search) url += `&search=${search}`;

  if (filter && Object.entries(filter)?.filter(([_, v]) => v)?.length) {
    Object.entries(filter).map(([key, value]) => {
      if (key === "or" || key === "and") {
        const logicalString = value
          .map((obj) => {
            const innerKey = Object.keys(obj)[0];
            const innerVal = obj[innerKey];
            return `{ "${innerKey}": "${innerVal}" }`;
          })
          .join(",");

        filterArr.push(`"${key}":[${logicalString}]`);
        return;
      }

      if (
        value !== null &&
        value !== undefined &&
        (Array.isArray(value) ? value.length > 0 : true)
      ) {
        // ✅ If key doesn’t end with a known suffix, append "_eq" by default
        const finalKey = /(_in|_gte|_lte|_eq|_like|_neq|_gt|_lt)$/.test(key)
          ? key
          : `${key}_eq`;

        filterArr.push(
          `"${finalKey}":${
            finalKey.endsWith("_in") && Array.isArray(value)
              ? `[${value.map((i) => `"${i}"`)}]`
              : finalKey.endsWith("_gte")
              ? finalKey.includes("_time")
                ? `"${value}"`
                : `"${dayjs(value).format("YYYY-MM-DD")} 00:00:00"`
              : finalKey.endsWith("_lte")
              ? finalKey.includes("_time")
                ? `"${value}"`
                : `"${dayjs(value).format("YYYY-MM-DD")} 23:59:59"`
              : typeof value === "string"
              ? `"${value}"`
              : value
          }`
        );
      }
    });
  }

  if (fileType) url += `&download_file_type=${fileType}`;
  // id, desc
  if (
    (!filter ||
      !Object.entries(filter)?.filter(([_, value]) => value)?.length) &&
    type
  ) {
    filterArr.push({ status_in: { type } });
  }
  if (sort?.[0]) {
    url += `&sort_by=${sort
      .map((d) => (d.desc ? `-${d.id}` : d.id))
      .join(",")}`;
  }
  if (filterArr.length) url += `&filters={${filterArr.join(",")}}`;
  return getAPICall(url, { returnObject: true });
};

// use : Master combo product
export const getAllDataV5 = ({
  source,
  page = -1,
  search,
  type,
  fileType,
  filter,
  sort,
}) => {
  let url = `${source}?page=${fileType ? -1 : page}`;
  let filterArr = [];
  if (search) url += `&search=${search}`;

  if (filter && Object.entries(filter)?.filter(([_, v]) => v)?.length) {
    Object.entries(filter).map(([key, value]) => {
      if (key === "or" || key === "and") {
        const logicalString = value
          .map((obj) => {
            const innerKey = Object.keys(obj)[0];
            const innerVal = obj[innerKey];
            return `{ "${innerKey}": "${innerVal}" }`;
          })
          .join(",");

        filterArr.push(`"${key}":[${logicalString}]`);
        return;
      }

      if (
        value !== null &&
        value !== undefined &&
        (Array.isArray(value) ? value.length > 0 : true)
      ) {
        // ✅ If key doesn’t end with a known suffix, append "_eq" by default
        const finalKey = /(_in|_gte|_lte|_eq|_like|_neq|_gt|_lt)$/.test(key)
          ? key
          : `${key}_eq`;

        filterArr.push(
          `"${finalKey}":${
            finalKey.endsWith("_in") && Array.isArray(value)
              ? `[${value.map((i) => `"${i}"`)}]`
              : finalKey.endsWith("_gte")
              ? finalKey.includes("_time")
                ? `"${value}"`
                : `"${dayjs(value).format("YYYY-MM-DD")} 00:00:00"`
              : finalKey.endsWith("_lte")
              ? finalKey.includes("_time")
                ? `"${value}"`
                : `"${dayjs(value).format("YYYY-MM-DD")} 23:59:59"`
              : typeof value === "string"
              ? `"${value}"`
              : value
          }`
        );
      }
    });
  }

  if (fileType) url += `&download_file_type=${fileType}`;
  // id, desc
  if (
    (!filter ||
      !Object.entries(filter)?.filter(([_, value]) => value)?.length) &&
    type
  ) {
    filterArr.push({ status_in: { type } });
  }
  if (sort?.[0]) {
    url += `&sort_by=${sort
      .map((d) => (d.desc ? `-${d.id}` : d.id))
      .join(",")}`;
  }
  if (filterArr.length) url += `&filters={${filterArr.join(",")}}`;
  return getAPICall(url, { returnObject: true });
};

export const getAllDataV3 = ({
  source,
  page,
  search,
  type,
  fileType,
  filter,
  filtersWithAction,
  sort
}) => {
  let url = `items/${source}?page=${fileType ? -1 : page}`
  let filters = []
  // let filterArr = []
  if (search) url += `&search=${search}`
  if (filter && Object.entries(filter)?.filter(([_, value]) => value)?.length) {
    filters.push(
      `${Object.entries(filter)
        .map(([key, value]) => `"${key}_eq":${value}`)
        .join(',')}`
    )

  }
  if (filtersWithAction?.length) {
    filters.push(
      `${filtersWithAction
        .map(item => `"${item?.key}_${item?.action}":${item?.value}`)
        .join(',')}`
    )
  }
  if (fileType) url += `&download_file_type=${fileType}`
  // id, desc
  if (
    (!filter ||
      !Object.entries(filter)?.filter(([_, value]) => value)?.length) &&
    type
  ) {
    url += `&filters={"status_in":[${type}]}`
    // filterArr.push({"status_in":{type}})
  }
  if (sort?.[0]) {
    url += `&sort_by=${sort.map(d => (d.desc ? `-${d.id}` : d.id)).join(',')}`
  }
  if (filters) url += `&filters={${filters.join(',')}}`
  // if (filterArr.length) url += `&filters={${filterArr.join(',')}}`
  return getAPICall(url, { returnObject: true })
}

export const getAllDataWithFilters = ({
  source,
  page,
  search,
  type,
  fileType,
  filter,
  sort
}) => {
  let url = `items/${source}?page=${fileType ? -1 : page}`
  if (search) url += `&search=${search}`
  if (filter && Object.entries(filter)?.filter(([_, value]) => value)?.length) {
    // url += `&filters={${Object.entries(filter).map(([key, value]) => `"${key}_eq":${value}`).join(",")}}`;
    url += `&filters={${filter
      .map(
        ({ key, value, condition = 'eq' }) =>
          `"${key}${condition ? `_${condition}` : ''}":${
            Array.isArray(value) ? JSON.stringify(value) : '"' + value + '"'
          }`
      )
      .join(',')}}`
  }
  if (fileType) url += `&download_file_type=${fileType}`
  // id, desc
  // if ((!filter || !Object.entries(filter)?.filter(([_, value]) => value)?.length) && type) url += `&filters={"status_in":[${type}]}`;
  if (sort?.[0]) {
    url += `&sort_by=${sort.map(d => (d.desc ? `-${d.id}` : d.id)).join(',')}`
  }
  return getAPICall(url, { returnObject: true })
}

export const getAllDataV2 = ({
  source,
  page,
  per_page = 10,
  summary,
  search,
  fileType,
  filter,
  sort,
  download
}) => {
  let url = `query/${source}?page=${fileType ? -1 : page}&per_page=${per_page}`
  if (search) url += `&search=${search}`
  if (summary) url += `&summary=${summary?.join(',')}`
  if (Array.isArray(filter) && filter.length) {
    url += `&filters=${filter
      .map(({ key, value, condition = '=' }) => `${key}${condition}'${value}'`)
      .join('_and_')}`
  }
  if (fileType) url += `&download_file_type=${fileType}`
  if (download) url += `&export_as_file=true`
  // id, desc
  if (Array.isArray(sort) && sort.length) {
    url += `&sort_by=${sort
      .map(d => (d.desc ? `${d.id} desc` : d.id))
      .join(',')}`
  }
  return getAPICall(url, { returnObject: true })
}

export const getAllDataV4 = ({ source, sort, ...props }) => {
  let url = `${source}`
  let filters = []
  if (props && Object.entries(props)?.filter(([_, value]) => value)?.length) {
    Object.entries(props).forEach(([key, value]) => {
      if (value) filters.push(`${key}=${value}`)
    })
  }
  if (filters.length) url += `?${filters.join('&')}`
  if (Array.isArray(sort) && sort.length) {
    url += `&sort_by=${sort
      .map(d => (d.desc ? `${d.id} desc` : d.id))
      .join(',')}`
  }
  return getAPICall(url, { returnObject: true })
}

export const getReportData = ({
  source,
  page,
  per_page = 10,
  summary,
  search,
  fileType,
  filter,
  sort,
  download
}) => {
  let url = `reports/${source}?page=${
    fileType ? -1 : page
  }&per_page=${per_page}`
  if (search) url += `&search=${search}`
  if (summary) url += `&summary=${summary?.join(',')}`
  if (Array.isArray(filter) && filter.length) {
    const filtersStr = `{${filter
      .map(
        ({ field, value }) =>
          `"${field}":${
            Array.isArray(value) ? '[' + value + ']' : '"' + value + '"'
          }`
      )
      .join(',')}}`
    url += `&filters=${encodeURIComponent(filtersStr)}`
  }
  if (fileType) url += `&download_file_type=${fileType}`
  if (download) url += `&export_as_file=true`
  // id, desc
  if (Array.isArray(sort) && sort.length) {
    url += `&sort_by=${sort
      .map(d => (d.desc ? `${d.id} desc` : d.id))
      .join(',')}`
  }
  return getAPICall(url, { returnObject: true })
}

export const getDataById = ({ id, source }) => {
  let url = `items/${source}/${id}`
  return getAPICall(url, { returnFirstItem: true })
}

export const getHeaders = ({ source }) => {
  return getAPICall(`fields/${source}?action=read&sort_by=sort`)
}

export const getDashBoardData = ({
  source,
  startDate,
  endDate,
  filter,
  fileType
}) => {
  let url = `dashboard/${source}?start_date=${dayjs(startDate).format(
    'YYYY-MM-DD'
  )}&end_date=${dayjs(endDate).format('YYYY-MM-DD')}`
  if (filter && Object.entries(filter)?.filter(([_, value]) => value)?.length) {
    url += `&filters={${Object.entries(filter)
      .map(([key, value]) => `"${key}":"${value}"`)
      .join(',')}}`
  }
  if (fileType) url += `&export_as_file=true`
  return getAPICall(url, { returnObject: true })
}

export const createNewRecord = ({ source, body }) => {
  return postAPICall(`items/${source}`, { body })
}

export const updateRecord = ({ source, body }) => {
  return patchAPICall(`items/${source}/${body.id}`, { body })
}

export const deleteRecord = ({ source, id }) => {
  return deleteAPICall(`items/${source}/${id}`)
}

export const cancelJourneyLeg = ({ journeyId, body }) => {
  return postAPICall(`journey/${journeyId}/cancel`, {
    body,
    returnObject: true
  })
}

export const bulkUpsert = ({ source, body }) => {
  return postAPICall(`bulk-upsert`, {
    body: Array.isArray(source)
      ? body
      : {
          [source]: body
        }
  })
}

export const hierarchicalInsert = ({ body }) => {
  return postAPICall(`hierarchical-insert`, {
    body: body
  })
}

export const editCompletedJourney = ({ body }) => {
  return postAPICall(`sales-edit-for-completed-journey-leg`, {
    body: body
  })
}

export const refreshSectorPattern = ({ journeyId }) => {
  return postAPICall(`refresh-sector-pattern/${journeyId}`, {})
}

export const getPaymentDetails = ({ filters }) => {
  let url = `query/customer_support_card_payment_recovery`;
  let options = [];

  if (filters) options.push(`filters=${filters}`);
  if (options.length) url += `?${options.join('&')}`
  return getAPICall(url, { returnObject: true });
};
